<template lang="html">
  <div class="dashboard-menu" :class="{ open: isOpen }">
    <div class="dashboard-menu__header">
      <a href="https://charidy.com" class="logo">
        <svg viewBox="0 0 336.85 76.07">
          <g fill="#FFF">
            <path
              d="M331.39 27.06h-4.02v.83h1.51v3.63h1V27.9h1.5v-.83zm4.52 0l-1.54 2.32-1.53-2.32h-.94v4.46h.93v-3.05l1.36 2.07h.37l1.36-2.08v3.06h.93v-4.46h-.94zM241.8 18.17c0-2.88-2.29-5.15-5.13-5.15s-5.13 2.28-5.13 5.15c0 2.83 2.3 5.15 5.13 5.15s5.14-2.32 5.14-5.15zM315.2 27.06l-8.84 23.72-8.5-23.72h-10.77l13.82 31.5a89.98 89.98 0 0 1-5.85 10.7l9.7 2.59c6.85-11.83 13.82-27.58 21-44.79h-10.57zM256.32 43.54v-.6c0-5.51 2.99-8.64 8.84-8.64 3.59 0 6.51.87 8.57 2.8v11.42c-2.13 1.93-4.58 2.93-8.64 2.93-5.51 0-8.77-2.66-8.77-7.91zm27.84 15.08c-.33-1.52-.53-4.58-.53-9.5V10.65h-9.9v18.67c-1.86-1.53-5.51-2.92-9.43-2.92-9.97 0-17.88 5.58-17.88 16.74v.8c0 10.23 7.9 15.28 16.35 15.28 5.91 0 9.57-2.26 11.56-4.32.13 1.2.4 2.73.8 3.72h9.03zM241.62 27.06h-9.9v31.56h9.9V27.06zM222.17 26.73c-4.46 0-7.51 2.66-8.77 7.57l-.54-7.24h-9.17v31.56h9.84V40.75c1.13-2.92 3.65-5.12 6.9-5.12 2 0 3.66.53 4.86 1.33l1.6-9.3c-1-.53-3.13-.93-4.72-.93zM172.13 48.72c0-2.85 2.4-3.65 7.04-3.65 3.13 0 6.12.53 8.44 1.33v3.19c-1.8 1.72-5.18 2.59-8.7 2.59-3.66 0-6.78-.53-6.78-3.46zm25.05 9.9c-.46-1.52-.66-3.52-.66-8.37 0-3.06.06-6.58.13-9.7.2-10.23-6.91-14.15-16.48-14.15a40.37 40.37 0 0 0-14.48 2.46l2.45 7.7c2.13-1.6 6.05-2.72 10.64-2.72 5.31 0 9.03 1.2 8.97 5.78l-.07 1.2a29.32 29.32 0 0 0-10.63-2.07c-7.9 0-14.22 2.46-14.22 10.37 0 7.24 6.78 10.1 13.55 10.1 6.45 0 9.84-2.13 11.63-3.99.2 1.13.47 2.4.73 3.4h8.44zM143.69 26.4c-5.65 0-9.37 2.32-11.23 4.58V10.65h-10.17v47.97h10.1V38.56c1.73-2.2 4.19-3.66 8.1-3.66 4.93 0 7.05 2.33 7.05 7.51v16.21h10.17v-16.8c0-9.71-4.78-15.42-14.02-15.42zM102.63 26.4c-10.97 0-18.74 6.38-18.74 16.4v.74c0 10.23 7.1 15.68 18.87 15.68 5.91 0 11.63-1.66 14.95-4.32l-3.59-7.5c-2.26 2.19-6.58 3.98-10.76 3.98-6.52 0-9.57-2.99-9.57-8.17v-.73c0-5.19 3.99-8.11 9.5-8.11 4.65 0 8.04.93 10.5 3.12l3.79-7.44c-3.73-2.32-8.77-3.65-14.95-3.65zM38.04 0c10.5 0 20 4.26 26.9 11.14a37.92 37.92 0 0 1 11.13 26.9c0 10.5-4.25 20.01-11.14 26.9-6.88 6.88-16.39 11.13-26.9 11.13s-20-4.25-26.89-11.14S0 48.54 0 38.03v-.38a37.92 37.92 0 0 1 11.14-26.5A37.92 37.92 0 0 1 38.04 0zM17.06 35.41a12.13 12.13 0 0 1 20.96-4.8c.2-.23.42-.45.63-.67a12.12 12.12 0 0 1 12.23-3.01 23.95 23.95 0 0 0-21.16-12.78c-6.6 0-12.57 2.67-16.89 7a23.8 23.8 0 0 0-7 16.57v.32c0 8.89 3.6 16.94 9.44 22.77a32.1 32.1 0 0 0 22.77 9.43c8.89 0 16.94-3.6 22.77-9.43a32.1 32.1 0 0 0 9.43-22.77c0-8.9-3.6-16.95-9.43-22.77a32.1 32.1 0 0 0-22.77-9.44c-4.79 0-9.33 1.05-13.41 2.92a29.63 29.63 0 0 1 26.11 8.27 29.63 29.63 0 0 1 8.69 20.07 21.45 21.45 0 0 1-21.4 22.34c-5.9 0-11.25-2.4-15.12-6.27a21.32 21.32 0 0 1-6.24-14.05c-.06-1.26.07-2.48.39-3.7zm36.53 3.04a6.32 6.32 0 0 0-10.81-4.39l-4.77 4.48-4.83-4.58a6.34 6.34 0 0 0-10.7 4.17 15.5 15.5 0 0 0 4.56 10.9 15.5 15.5 0 0 0 22 0 15.5 15.5 0 0 0 4.55-10.58z"
            />
          </g>
        </svg>
      </a>
    </div>

    <nav class="dashboard-nav-wrapper">
      <ul class="dashboard-nav">
        <li>
          <router-link to="/vendor-dashboard" class="dashboard-nav__link">
            <svg viewBox="0 0 27 22">
              <g fill="none" fill-rule="nonzero">
                <path
                  fill="#FFF"
                  d="M3.86 21.87c.12 0 .23-.03.34-.09 2.34-1.39 5.66-2.18 9.1-2.18 3.45 0 6.77.8 9.12 2.18.27.16.62.1.83-.14a13.1 13.1 0 1 0-19.89 0c.13.16.32.23.5.23zm2.7-4l-1.51.88a.66.66 0 0 1-.9-.24.66.66 0 0 1 .23-.9l1.5-.88a.66.66 0 1 1 .67 1.14zm16.14.59a.66.66 0 0 1-.9.24l-1.5-.86a.66.66 0 1 1 .65-1.15l1.51.87c.32.18.43.58.24.9zm1.22-5.33c0 .36-.3.66-.66.66H21.5a.66.66 0 0 1 0-1.32h1.75c.36 0 .66.3.66.66zm-3.83-4.65l1.5-.87a.66.66 0 0 1 .67 1.14l-1.51.87a.66.66 0 1 1-.66-1.14zm-3.24-2.72l.86-1.52a.66.66 0 0 1 1.15.66L18 6.4a.66.66 0 1 1-1.15-.65zm-4.2-2.59a.66.66 0 0 1 1.32 0v1.75a.66.66 0 0 1-1.32 0V3.17zm-4.5.86a.66.66 0 0 1 .9.24l.88 1.5a.66.66 0 1 1-1.14.67L7.9 4.93a.66.66 0 0 1 .24-.9zM4.3 7.9a.66.66 0 0 1 .9-.25l1.5.87a.66.66 0 1 1-.65 1.15l-1.5-.87a.66.66 0 0 1-.25-.9zm-1.6 5.23c0-.37.29-.66.65-.66H5.1a.66.66 0 0 1 0 1.32H3.35a.66.66 0 0 1-.66-.66z"
                />
                <path
                  fill="#107598"
                  d="M11.68 11.77c.75-.68 6.35-3.35 6.58-3.46a.24.24 0 0 1 .32.34c-.14.23-3.42 5.49-4.18 6.16a2.04 2.04 0 1 1-2.72-3.04z"
                />
              </g>
            </svg>
            {{ $t("template.dashboard") }}
          </router-link>
        </li>

        <li>
          <router-link to="/profile-tabs" class="dashboard-nav__link">
            <svg viewBox="0 0 27 23">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M1.64 9.04v12.32c0 .9.74 1.64 1.65 1.64h3.28c.9 0 1.64-.74 1.64-1.64V4.92L4.73 6.85a3.3 3.3 0 0 1-3.09 2.19zM14 9.4L9.86 5.7v15.66c0 .9.74 1.64 1.64 1.64h3.29c.9 0 1.64-.74 1.64-1.64V12.2a3.29 3.29 0 0 1-2.44-2.79zm4.08 2.8v9.15c0 .9.74 1.64 1.64 1.64H23c.9 0 1.64-.74 1.64-1.64V5.13l-4.11 4.11a3.28 3.28 0 0 1-2.46 2.96z"
                />
                <path
                  d="M24.64 0a1.64 1.64 0 0 0-1.58 2.06l-5.39 5.4a1.6 1.6 0 0 0-.42-.07c-.18 0-.34.04-.5.09l-6.1-5.5a1.64 1.64 0 1 0-3.25-.37L2.48 4.34a1.64 1.64 0 1 0 .8 1.43L8.2 3.06c.24.15.53.24.84.24.17 0 .34-.04.5-.1l6.1 5.5a1.64 1.64 0 1 0 3.19-.08l5.4-5.39c.13.04.27.07.41.07a1.64 1.64 0 0 0 0-3.29z"
                />
              </g>
            </svg>
            Profiles
          </router-link>
        </li>

        <li>
          <router-link
            @click.native="sidebarMenuClose"
            to="/packages-page"
            class="dashboard-nav__link"
          >
            <svg viewBox="0 0 24 26">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M7.92 22.11A3 3 0 0 0 10.76 26a3 3 0 0 0 2.84-3.89H7.92zM19.43 16.74V13.69A5.82 5.82 0 0 1 15 3.4a7.95 7.95 0 0 0-2.04-.78c.03-.12.03-.24.03-.39A2.26 2.26 0 0 0 10.76 0a2.26 2.26 0 0 0-2.24 2.24l.03.39a8.39 8.39 0 0 0-6.46 8.19v5.92A2.1 2.1 0 0 0 0 18.83c0 1.13.96 2.09 2.1 2.09h17.33c1.13 0 2.09-.96 2.09-2.1a2.1 2.1 0 0 0-2.1-2.08z"
                />
                <circle cx="18.68" cy="7.92" r="4.63" />
              </g>
            </svg>
            Packages
          </router-link>
        </li>

        <li>
          <router-link to="/vendor-users" class="dashboard-nav__link">
            <svg viewBox="0 0 448 512">
              <path
                fill="currentColor"
                d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
              ></path>
            </svg>
            {{ $t("template.users") }}
          </router-link>
        </li>

        <li>
          <router-link to="/vendor-billing" class="dashboard-nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style="fill: #fff"
            >
              <path
                d="M17.478,14.084c-0.348-0.609-0.89-1.144-1.624-1.603c-0.735-0.46-1.758-0.881-3.068-1.264 c-1.31-0.382-2.251-0.807-2.822-1.276C9.392,9.474,9.106,8.845,9.106,8.056c0-0.85,0.271-1.514,0.813-1.989 c0.541-0.476,1.323-0.713,2.345-0.713c0.979,0,1.758,0.321,2.333,0.964c0.27,0.301,0.476,0.651,0.62,1.05 c0.071,0.199,0.199,0.659,0.206,0.679C15.624,8.649,15.967,9,16.559,9c0.654,0,1.184-0.414,1.184-1.184 c0-0.145-0.031-0.298-0.05-0.388c-0.18-0.896-0.535-1.645-1.067-2.248c-0.804-0.91-1.927-1.455-3.371-1.632L13.25,3.547V2 c0-0.552-0.448-1-1-1s-1,0.448-1,1v1.551C9.858,3.716,8.756,4.19,7.953,4.983C7.132,5.794,6.721,6.832,6.721,8.098 c0,1.243,0.419,2.268,1.257,3.075c0.838,0.806,2.172,1.461,4.002,1.963c1.315,0.394,2.249,0.834,2.804,1.32 c0.553,0.487,0.831,1.085,0.831,1.795c0,0.842-0.323,1.506-0.967,1.992c-0.645,0.486-1.53,0.729-2.656,0.729 c-1.151,0-2.165-0.289-2.792-0.868c-0.422-0.389-0.701-0.89-0.839-1.503c-0.005-0.023-0.078-0.258-0.13-0.355 c-0.196-0.37-0.595-0.619-1.044-0.619C6.532,15.625,6,16.157,6,16.813c0,0.288,0.144,0.696,0.188,0.816 c0.225,0.615,0.59,1.174,1.047,1.625c0.883,0.869,2.225,1.37,3.765,1.517V22c0,0.552,0.447,1,0.999,1s1-0.448,1-1v-1.21l0.025-0.001 c1.572-0.147,2.795-0.617,3.667-1.413C17.563,18.581,18,17.531,18,16.227C18,15.409,17.825,14.694,17.478,14.084z"
              ></path>
            </svg>
            {{ $t("template.billing") }}
          </router-link>
        </li>

        <li>
          <router-link to="/vendor-gateways" class="dashboard-nav__link">
            <svg viewBox="0 0 27 19">
              <g fill="#FFF" fill-rule="evenodd">
                <path
                  fill-rule="nonzero"
                  d="M.14 8.15v7.04c0 1.8 1.46 3.26 3.25 3.26h20.15c1.8 0 3.25-1.46 3.25-3.26V8.15H.14zM21.4 14.9c-.53 0-.98-.26-1.26-.65-.28.4-.76.65-1.26.65a1.6 1.6 0 1 1 0-3.2c.53 0 .98.25 1.26.64.28-.36.76-.64 1.26-.64a1.6 1.6 0 1 1 0 3.2z"
                />
                <path
                  d="M23.54.22H3.39A3.25 3.25 0 0 0 .14 3.45v1.94h26.65V3.45A3.25 3.25 0 0 0 23.54.22z"
                />
              </g>
            </svg>
            {{ $t("template.gateways") }}
          </router-link>
        </li>
      </ul>
    </nav>

    <svg class="dashboard-menu__deco" viewBox="0 0 181 260">
      <path
        fill="#FFF"
        fill-rule="evenodd"
        d="M103.5 131.42a21.52 21.52 0 0 0-6.48-15.12 21.78 21.78 0 0 0-15.33-6.23 21.8 21.8 0 0 0-15.4 6.34L49.85 131.7l-16.62-15.65a21.9 21.9 0 0 0-15.07-5.98c-6 0-11.42 2.38-15.33 6.23a21.55 21.55 0 0 0-6.45 14.02 52.85 52.85 0 0 0 15.69 37.28 53.62 53.62 0 0 0 37.88 15.58 53.6 53.6 0 0 0 37.88-15.58 52.82 52.82 0 0 0 15.67-36.18zm-125.77-10.39a41.31 41.31 0 0 1 10.99-18.83 41.9 41.9 0 0 1 29.45-12.06 41.94 41.94 0 0 1 31.74 14.5 41.9 41.9 0 0 1 31.77-14.5c4.35 0 8.54.66 12.48 1.89a82.29 82.29 0 0 0-72.83-43.67 82.29 82.29 0 0 0-58.16 23.9 81.09 81.09 0 0 0-24.08 56.65V130c0 30.4 12.4 57.9 32.47 77.82a110.94 110.94 0 0 0 78.4 32.24c30.61 0 58.33-12.32 78.4-32.24A109.32 109.32 0 0 0 160.83 130c0-30.4-12.41-57.91-32.47-77.83a110.95 110.95 0 0 0-78.4-32.23c-16.48 0-32.11 3.56-46.17 9.97 5.7-.98 11.56-1.5 17.54-1.5 28.26 0 53.84 11.38 72.36 29.76a100.9 100.9 0 0 1 29.92 68.59c.64 20.71-6.71 40.2-21.57 54.94a73.69 73.69 0 0 1-52.08 21.42A73.68 73.68 0 0 1-2.12 181.7a72.62 72.62 0 0 1-21.49-48.02 40.8 40.8 0 0 1 1.34-12.65zM49.96 0c36.16 0 68.9 14.55 92.6 38.07A129.13 129.13 0 0 1 180.9 130c0 35.9-14.66 68.4-38.35 91.92A131.04 131.04 0 0 1 49.96 260c-36.17 0-68.9-14.55-92.6-38.08A129.12 129.12 0 0 1-81 128.7a129.12 129.12 0 0 1 38.35-90.62A131.02 131.02 0 0 1 49.96 0z"
        opacity=".08"
      />
    </svg>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isOpen: (state) => state.vendorMain.sidebarOpen,
    }),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.dashboard-menu {
  width: 320px;
  overflow-y: auto;
  font-family: $vito-light;
  background-color: $bb-100;
  transition: left 0.2s ease-in-out;
  position: fixed;
  left: -320px;
  top: 90px;
  bottom: 0;
  z-index: 100;
  @media only screen and (min-width: 1360px) {
    top: 0;
    left: 0;
    width: 300px;
  }

  &.open {
    left: 0;
  }

  &__header {
    width: 100%;
    height: 90px;
    padding: 0 20px;
    align-items: center;
    justify-content: flex-start;
    background-color: $bb-90;
    display: none;
    @media only screen and (min-width: 1360px) {
      display: flex;
      height: 90px;
      justify-content: center;
    }
    > .logo {
      display: inline-block;
      margin: 0;
      svg {
        width: 150px;
        height: auto;
      }
    }
  }

  &__user {
    height: 80px;
    padding-left: 60px;
    display: flex;
    margin-bottom: 10px;
    @media only screen and (min-width: 1360px) {
      padding-left: 40px;
    }
  }

  &__deco {
    width: 200px;
    position: absolute;
    bottom: 20px;
    left: 0;
    z-index: -1;
  }
}

.user-info {
  display: flex;
  width: 200px;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  position: relative;
  cursor: pointer;

  &__name {
    padding: 0 10px;
    font-size: 18px;
    line-height: 1.25;
    color: #ffffff;
    flex-grow: 2;
    max-height: 66px;
    overflow: hidden;
  }

  &__avatar {
    width: 44px;
    min-width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-right: 5px;
    overflow: hidden;
    img {
      width: 100%;
      min-height: 100%;
      object-fit: cover;
    }
  }

  &__chevron {
    min-width: 24px;
    margin-right: 5px;
  }

  .drop-menu {
    margin: 0;
    padding: 5px 0px;
    background-color: #ffffff;
    position: absolute;
    z-index: 2;
    width: 280px;
    box-sizing: border-box;
    border-radius: 4px;
    top: 105%;
    left: -50px;
    box-shadow: $shadow-main;
    @media only screen and (min-width: 1360px) {
      left: -30px;
    }

    &__links {
      margin: 0;

      li:not(:last-of-type) {
        position: relative;
        &:after {
          content: "";
          display: block;
          width: calc(100% - 50px);
          height: 1px;
          background-color: $bg-50;
          position: absolute;
          bottom: 0px;
          left: 25px;
        }
      }
      li:nth-last-of-type(4) {
        &:after {
          background-color: $bb-50;
        }
      }
    }

    &__item {
      display: block;
      font-size: 18px;
      padding: 15px 25px;
      color: $fd;

      &:hover {
        background-color: $bg-50;
        color: $bb-100;
        text-decoration: none;
      }

      &.router-link-exact-active {
        color: $bb-100;
      }
      &--vs-ava {
        display: flex;
        max-width: 100%;
        min-height: 57px;
        padding: 0 25px;
        align-items: center;
        > span {
          flex-grow: 1;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .avatar {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px;

        &--red {
          background-color: $lr-50;
          .avatar__char {
            color: $lr-100;
          }
        }

        &__char {
          display: inline-flex;
          font-family: $vito-bold;
          font-size: 14px;
          text-transform: uppercase;
          line-height: 1;
          margin-bottom: -1px;
        }
      }
    }
  }
}

.dashboard-nav-wrapper {
  padding-left: 60px;
  @media only screen and (min-width: 1360px) {
    padding-left: 40px;
  }
}

.dashboard-nav {
  list-style: none;
  padding: 0;
  margin: 0;

  &__link {
    height: 56px;
    display: flex;
    align-items: center;
    font-family: $vito-light;
    font-size: 16px;
    letter-spacing: 1px;
    color: #ffffff;
    position: relative;
    &:hover {
      color: #fff;
      font-family: $vito-bold;
      text-decoration: none;
    }
    &.active-link {
      opacity: 1;
      font-family: $vito-bold;
    }
    > svg {
      width: 27px;
      height: auto;
      margin-right: 20px;
      display: block;
    }
  }

  ::v-deep button {
    font-family: $vito-light;
    background: transparent;
    margin: 0 !important;
    padding: 0;
    border: 0;
    color: #ffffff;
    &:hover {
      color: #fff;
      font-family: $vito-bold;
      text-decoration: none;
    }
  }
  ::v-deep button + div .active-link {
    color: #fff;
    font-family: $vito-bold;
  }
  ::v-deep #traning {
    padding-left: 20px;
  }
}
</style>
